import { Category } from '@wix/answers-api';

export type CategoriesTreeSlice = {
  categoriesTree: Category[];
};

export const getCategoriesTreeInitialState = (): CategoriesTreeSlice => ({
  categoriesTree: [],
});
